import Fetch from 'jsx/common/util/_fetch';

export const logout = async () => {
  const response = await Fetch.post('/api/me/logout/');
  if (response.status !== 200) throw new Error(response.statusText);
  const result = await response.json();
  window.location.href = result.redirect;
};
